"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggedNotificationController = void 0;
const workers_1 = require("../services/workers");
const storage_1 = require("../services/storage");
const notifications_1 = require("../services/notifications");
const common_1 = require("../utils/common");
const constants_1 = require("../constants");
function loggedNotificationController({ worker, context, userPq, userRecom, customer, addNotifications, }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const userId = context === null || context === void 0 ? void 0 : context.userIdPartyHash;
        const { cachedUnreadNotifications, cachedNotifications } = yield (0, storage_1.getCachedNotifications)({ userId });
        let { outdatedNotis, upToDateNotis } = (0, notifications_1.clusterNotificationTypesByExpiration)(cachedNotifications);
        const finalNotifications = Object.assign({}, (cachedNotifications || {}));
        let unreadNotifications = cachedUnreadNotifications;
        if (upToDateNotis.length > 0) {
            const cachedUpToDateNotis = (0, common_1.filterObjectKeys)(cachedNotifications, outdatedNotis);
            addNotifications({
                notifications: cachedUpToDateNotis,
                unreadNotifications,
            });
        }
        if (outdatedNotis.length > 0) {
            if (!worker) {
                worker = yield (0, workers_1.spawnWorkerInstance)(constants_1.WORKER_TYPES.NOTIFICATION);
            }
            if (!worker) {
                addNotifications({
                    notifications: {},
                    unreadNotifications: [],
                    finish: true,
                });
                return;
            }
            if (outdatedNotis.includes("commertial")) {
                outdatedNotis = (0, common_1.removeItemFromArr)(outdatedNotis, "commertial");
                const commertialRes = yield worker.getNotifications({
                    context,
                    userPq,
                    userRecom,
                    customer,
                }, ["commertial"]);
                const cachedCommertial = (cachedNotifications === null || cachedNotifications === void 0 ? void 0 : cachedNotifications["commertial"]) || {};
                const currentCommertial = (_a = commertialRes === null || commertialRes === void 0 ? void 0 : commertialRes.notifications) === null || _a === void 0 ? void 0 : _a.commertial;
                const { notification: commertial, unreadHashList } = (0, notifications_1.normalizeReadNotification)(cachedCommertial, currentCommertial);
                unreadNotifications = (0, common_1.mergeArryUnique)(unreadNotifications, unreadHashList);
                finalNotifications.commertial = commertial;
                yield (0, storage_1.setCachedNotifications)({
                    userId,
                    notifications: finalNotifications,
                    unreadNotifications,
                });
                addNotifications({
                    notifications: { commertial },
                    unreadNotifications,
                });
            }
            const { notifications } = yield worker.getNotifications({
                context,
                userPq,
                userRecom,
                customer,
            }, outdatedNotis);
            Object.entries(notifications).forEach(([key, value]) => {
                const cachedNoti = cachedNotifications === null || cachedNotifications === void 0 ? void 0 : cachedNotifications[key];
                const { notification, unreadHashList } = (0, notifications_1.normalizeReadNotification)(cachedNoti, value);
                finalNotifications[key] = notification;
                unreadNotifications = (0, common_1.mergeArryUnique)(unreadNotifications, unreadHashList);
            });
        }
        yield (0, storage_1.setCachedNotifications)({
            userId,
            notifications: finalNotifications,
            unreadNotifications,
        });
        addNotifications({
            notifications: finalNotifications,
            unreadNotifications,
            finish: true,
        });
    });
}
exports.loggedNotificationController = loggedNotificationController;
exports.default = loggedNotificationController;
//# sourceMappingURL=logged.js.map